// extracted by mini-css-extract-plugin
export default {"event":"EventItem_event__LQuLe","actions":"EventItem_actions__F6zf4"};